// Loaded from https://github.com/rgalex2034/text-roller.
// It is not set-up as an NPM package.
const TextRoller = (function () {
	//Helper functions
	function getWidth(element) {
		const rect = element.getBoundingClientRect();
		return rect.right - rect.left;
	}

	function TextRoller(box, speed = 20) {
		const inner_element = (box.children && box.children[0]) || null;
		if (!inner_element) throw 'No child node found';

		inner_element.style.position = 'relative';

		this.position = 0;
		this.speed = speed;
		this.box_width = getWidth(box);
		this.inner_element_width = getWidth(inner_element);
		this.box = box;
		this.inner_element = inner_element.cloneNode(true);
		setUpChildrens.call(this);
	}

	//Private functions
	function refreshWidths() {
		this.box_width = getWidth(this.box);
		this.inner_element_width = getWidth(this.box.children[0]);
	}

	function calculateNumElements() {
		return Math.ceil(this.box_width / this.inner_element_width) + 1;
	}

	function setUpChildrens() {
		let i;
		const qty = calculateNumElements.call(this);
		if (qty > this.box.children.length) {
			for (i = this.box.children.length; i < qty; i++)
				this.box.appendChild(this.inner_element.cloneNode(true));
		} else if (qty < this.box.children.length) {
			for (i = qty; i < this.box.children.length; i++)
				this.box.removeChild(this.box.lastChild);
		}
	}

	function nextFrame(delta) {
		const self = this;
		refreshWidths.call(this);
		setUpChildrens.call(this);
		Array.prototype.forEach.call(this.box.children, function (el) {
			el.style.left = -self.position + 'px';
		});
		this.position += (this.speed * delta) / 1000;
		if (this.position >= this.inner_element_width)
			this.position = this.position % this.inner_element_width;
	}

	TextRoller.prototype = {
		start: function () {
			this._running = true;
			const self = this;
			let last_time = null;
			const loop_func = function () {
				if (!self._running) return;
				const now = Date.now();
				const delta = last_time === null ? 0 : now - last_time;
				nextFrame.call(self, delta);
				last_time = now;
				window.requestAnimationFrame(loop_func);
			};
			window.requestAnimationFrame(loop_func);
		},

		stop: function () {
			this._running = false;
		},
	};

	return TextRoller;
})();

Alpine.data('homeMarquee', () => {
	return {
		init() {
			this.initMarquee();
			this.initEnterView();
		},
		inView(el) {
			const rect = el.getBoundingClientRect();

			return (
				rect.top >= 0 &&
				rect.left >= 0 &&
				rect.bottom <=
					(window.innerHeight || document.documentElement.clientHeight) &&
				rect.right <=
					(window.innerWidth || document.documentElement.clientWidth)
			);
		},
		initEnterView() {
			const letters = this.$refs.message.querySelectorAll('.highlight');

			if (!letters.length) return;

			setInterval(() => {
				letters.forEach((letter) => {
					letter.classList.toggle('highlight--active', this.inView(letter));
				});
			}, 1500);
		},
		initMarquee() {
			const t = new TextRoller(this.$refs.message, 100);

			t.start();
		},
	};
});
